import Swiper from 'swiper/bundle';
import {buttonFilledSvg, buttonOutlineSvg} from "../app";

const selector = document.querySelector('.b-product-carousel');


/**
 * Update markup with new data
 *
 * Example data:
 *  {
 *   title: 'Title Here',
 *   subtitle: 'Subtitle Here',
 *   items: [
 *     {
 *       "id": "1",
 *       "title":"Grilled Venison Burger with Cherry Salsa",
 *       "url":"https:\/\/www.kingsford.com\/recipes\/grilled-venison-burger-with-cherry-salsa\/",
 *       "post_type":"wprm_recipe",
 *       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2018\/10\/180619_VenisonBurger_271_800x800-672x372.jpg",
 *       "bvId":"KF_RECIPE_2826",
 *       "rating":null,
 *       "icon_name":"star"
 *     },
 *     {
 *       "id": "2",
 *       "title":"Smoky Rattlesnake Chili",
 *       "url":"https:\/\/www.kingsford.com\/recipes\/smoky-rattlesnake-chili\/",
 *       "post_type":"wprm_recipe",
 *       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2019\/05\/rattlesnake-chili_v2-672x372.jpg",
 *       "bvId":"KF_RECIPE_5803",
 *       "rating":null,
 *       "icon_name":"star"
 *     },
 *     {
 *       "id": "3",
 *       "title":"Juicy Lucy Burgers",
 *       "url":"https:\/\/www.kingsford.com\/recipes\/juicy-lucy-burgers\/",
 *       "post_type":"wprm_recipe",
 *       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2021\/03\/RL_JuicyLucyBurgerV.1-672x372.jpg",
 *       "bvId":"juicy-lucy-burgers",
 *       "rating":null,
 *       "icon_name":"steak"
 *     },
 *     {
 *       "id": "4",
 *       "title":"Huevos Rancheros",
 *       "url":"https:\/\/www.kingsford.com\/recipes\/series\/30-min-meals\/huevos-rancheros\/",
 *       "post_type":"wprm_recipe",
 *       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2021\/08\/Huevos-Rancheros-500x372.jpg",
 *       "bvId":"huevos-rancheros",
 *       "rating":null,
 *       "icon_name":"star"
 *     },
 *     {
 *       "id": "5",
 *       "title":"Stuffin&#8217; Waffles",
 *       "url":"https:\/\/www.kingsford.com\/recipes\/stuffin-waffles\/",
 *       "post_type":"wprm_recipe",
 *       "image_url":"https:\/\/www.kingsford.com\/wp-content\/uploads\/2020\/10\/StuffingWaffles-800x800-1-672x372.jpg",
 *       "bvId":"KF_RECIPE_8200",
 *       "rating":1.5,
 *       "icon_name":"star"
 *     }
 *   ],
 *   cta_text: 'CTA Text Here',
 *   cta_link: 'https://google.com/',
 * }
 *
 * @param id element to update
 * @param data replacement data
 */
function replaceProductCarouselData(id, data) {
    if(!id){
        console.error('No ID provided');
        return;
    }
    try {
        const { swiper } = this;
        const section = document.getElementById(id);

        /*
         * Map lytics slider data into swiper ready data, before removing all slides.
         */
        const lyticsSlider = section.querySelector('.slide--lytics-card');
        let lyticsData = null;
        if(lyticsSlider){
            lyticsData = {
                id: lyticsSlider.dataset.id,
                post_type: 'lytics',
                title: lyticsSlider.querySelector('.b-product-carousel__recipe-card .card__inner h3').innerHTML,
                cta_text: lyticsSlider.querySelector('.b-product-carousel__recipe-card .card__inner a span').innerHTML,
                cta_link: lyticsSlider.querySelector('.b-product-carousel__recipe-card .card__inner a').href,
            };
        }

        /*
         * Update the main slider's section.
         */
        if(data.title && data.title !== '') {
            setTitle(section, data.title);
        }
        if (data.subtitle && data.subtitle !== '') {
            setSubtitle(section, data.subtitle);
        }
        if(data.eyebrow && data.eyebrow !== '') {
            setEyeBrow(section, data.eyebrow);
        }
        if(data.cta_link &&  data.cta_link !== '' && data.cta_text && data.cta_text !== '') {
            setCallToAction(section, { href: data.cta_link, label: data.cta_text });
        }

        /*
         * Add lyticsData to be the first slide.
         */
        if(lyticsData){
            data.items.unshift(lyticsData);
        }

        /*
         * Destroy the slider!
         */
        if(data.items && data.items.length > 0){
            swiper.removeAllSlides();
            data.items.forEach(item => {
                const slideTypes = {
                    lytics: createLyticsSlideItem,
                };
                const slideItem = slideTypes[item.post_type] ? slideTypes[item.post_type](item) : createSlideItem(item);
                if(slideItem){
                    swiper.appendSlide(slideItem);
                }
            });
            swiper.destroy();
            productCarousel();
        }
    } catch (e) {
        console.warn(e);
    }
}

// helper fns
const setTitle = (section, value) => {
    const element = section.querySelector('.headline__text')
    if (element) {
        element.innerHTML = value;
    }
};
const setSubtitle = (section, value) => {
    const element = section.querySelector(`.text-group .text-group__paragraph .paragraph__text`);
    if (element) {
        element.innerHTML = value;
    };
};
const setEyeBrow = (section, value) => {
    const element = section.querySelector(`.text-group .text-group__eyebrow .eyebrow__text`);
    if (element) {
        element.innerHTML = value;
    }
}
const setCallToAction = (section, value) => {
    const element = section.querySelector(`.wrapper-cta .e-button`);
    if (element) {
        element.href = value.href;
        element.innerHTML = `<span class="e-button__background outline">${buttonOutlineSvg}</span>`;
        element.innerHTML += `<span class="e-button__background filled">${buttonFilledSvg}</span>`;
        element.innerHTML += `<span class="e-button__copy">${value.label}</span>`;
    }
};


/**
 * create a single slide item for Product
 *
 * @param item data for slide
 * @returns {*} markup for slide
 */
const createSlideItem = (item) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    slide.innerHTML = `
    <div data-id="${item.id}" class="b-product-carousel__recipe-card c-recipe-card">
        <a href="${item.url}">
            <div class="c-recipe-card__thumbnail-wrapper">
                <div class="c-recipe-card__overlay"></div>
                <div class="c-recipe-card__no-badge"></div>
                <picture class="b-product-carousel__recipe-card e-picture e-picture--4/3-ratio e-picture--rounded-none e-picture--border-none">
                    <img src="${item.image_url}?quality=50" alt="" height="254" width="338" loading="lazy" />
                </picture>
            </div>

            <p class="h6 c-recipe-card__title">
                <span class="fancy-link">${item.title}</span>
            </p>

            <div class="c-recipe-card__rating white e-rating">
                ${createRatingElement(item.rating)}
            </div>
        </a>
    </div>`;

    return slide;
};

/**
 * Creates a single lytics slide.
 *
 * @param item
 */
const createLyticsSlideItem = (item) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide', 'slide--lytics-card', 'lytics-disable');

    slide.innerHTML = `
    <div data-id="${item.id}" class="b-product-carousel__recipe-card c-recipe-card card--cta">
        <div class="c-recipe-card__thumbnail-wrapper">
            <div class="c-recipe-card__badge e-card-badge e-card-badge--primary">

            </div>
            <div class="b-product-carousel__recipe-card">
                <div class="card__padding"></div>
                <div class="card__inner">
                    <h3>${item.title}</h3>
                    <a class="e-button e-button--primary e-button--large" href="${item.cta_link}">
                        <span class="e-button__copy">${item.cta_text}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>`;

    return slide;
};

/**
 * add rating element for reviewed items
 *
 * @param rating
 * @returns {string}
 */
const createRatingElement = (rating = 0) => {
    let html = '';
    if (rating > 0 ) {
        html += `<img src={'/wp-content/themes/electro/img/svg/full-star-dark.svg'} alt={'Star'} height="18" width="18" /><span class="e-rating__rating">${parseFloat(rating).toFixed(1)}</span>`;
    }
    return html;
};

const swiperOptions = {
    loop: false,
    slidesPerView: 2.1,
    spaceBetween: 16,
    scrollbar: {
        el: selector.querySelector('.swiper-scrollbar'),
        horizontalClass: '.swiper-kfd-scrollbar',
        draggable: true,
        dragSize: 100,
    },
    navigation: {
        nextEl: selector.querySelector('.js-carousel-next'),
        prevEl: selector.querySelector('.js-carousel-prev'),
    },
    breakpoints: {
        620: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 12,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 16,
            scrollbar: {
                dragSize: 300,
            },
        },
    },
};

// create swiper & setup replacement fn
function productCarousel() {
    const swiper = new Swiper(selector.querySelector('.swiper'), swiperOptions);
    window.replaceProductCarouselData = replaceProductCarouselData.bind({ swiper });
}

productCarousel();
